import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import { news, clinicInteriorImage } from '../mock';

const NewsPage = () => {
  return (
    <div className="App bg-white">
      <Header />
      <PageHero
        eyebrow="Physiotherapy Blog"
        title="Helpful rehab"
        italic="guides."
        description="Practical articles about physiotherapy, recovery, injury prevention, and services available at Uptown Physiotherapy Clinic."
        image={clinicInteriorImage}
        breadcrumbs={[{ label: 'Home', to: '/' }, { label: 'News' }]}
      />

      <section className="py-16 lg:py-24">
        <div className="max-w-[1240px] mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {news.map((n) => (
            <Link key={n.id} to={`/news/${n.slug}`} className="group rounded-[24px] border border-neutral-200 overflow-hidden hover:border-[#CA0028] transition-colors">
              <div className="aspect-[4/3] overflow-hidden bg-neutral-100">
                <img src={n.image} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-[12px] text-neutral-500">
                  <span className="font-medium text-neutral-700">{n.tag}</span>
                  <span className="w-1 h-1 rounded-full bg-neutral-300" />
                  <span>{n.date}</span>
                </div>
                <h3 className="mt-3 text-[19px] font-semibold text-neutral-900 leading-snug group-hover:text-[#CA0028] transition-colors">
                  {n.title}
                </h3>
                <p className="mt-3 text-[14px] text-neutral-600 leading-relaxed">{n.excerpt}</p>
                <div className="mt-5 inline-flex items-center gap-1 text-[13px] font-medium text-neutral-900">
                  Read more <ArrowUpRight size={14} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NewsPage;
